import { createSlice } from '@reduxjs/toolkit';

const uiSlice = createSlice({
  name: 'ui',
  initialState: {
    sidebarOpen: false,
    theme: 'light',
    isSearchOpen: false,
    modal: { isOpen: false, type: null, data: null },
  },
  reducers: {
    toggleSidebar: (state) => { state.sidebarOpen = !state.sidebarOpen; },
    setSidebarOpen: (state, action) => { state.sidebarOpen = action.payload; },
    setTheme: (state, action) => { state.theme = action.payload; },
    toggleTheme: (state) => { state.theme = state.theme === 'light' ? 'dark' : 'light'; },
    setSearchOpen: (state, action) => { state.isSearchOpen = action.payload; },
    openModal: (state, action) => {
      state.modal = { isOpen: true, type: action.payload.type, data: action.payload.data };
    },
    closeModal: (state) => {
      state.modal = { isOpen: false, type: null, data: null };
    },
  },
});

export const { toggleSidebar, setSidebarOpen, setTheme, toggleTheme, setSearchOpen, openModal, closeModal } = uiSlice.actions;
export default uiSlice.reducer;
